export default __webpack_public_path__ + "static/8-instagram-travel-bloggers-you-should-be-following-9166323382b6d93777536dccf781b36a.jpg";